export default __webpack_public_path__ + "static/media/icons.009b52df.svg";